import { render, staticRenderFns } from "./CustomizeMetalJ.vue?vue&type=template&id=0bc4da44&scoped=true"
import script from "./CustomizeMetalJ.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalJ.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalJ.vue?vue&type=style&index=0&id=0bc4da44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4da44",
  null
  
)

export default component.exports